import CardHeader from '../../../antd/components/CardHeader';
import ModalDelete from '../../../Components/Shared/ModalDelete';
import { CreatePleaModal } from "../../../Components/Plea/CreatePleaModal";
import { PleaModel } from "../../../Models/PleaModel";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import TablePaginationFooter from "../../../Components/Shared/TableDefault/Pagination";
import { FillTable } from "../../../Components/Shared/FillTable";
import { PaginationModel } from "../../../Models/PaginationModel";
import Loader from "../../../Components/Shared/Loader";
import useModal from "../../../Hooks/useModal";
import { toast } from "react-toastify";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { DeleteRegisterAPI } from "../../../API/RegisterAPI";
import { DeletePleaAPI, GetAllByCompanyId, GetAllPleaPaginatedAPI } from "../../../API/PleaAPI";
import { Button, Card, Table, Space, Input } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import type { ColumnType } from 'antd/es/table';
import type { FilterConfirmProps } from 'antd/es/table/interface';

export default function CardsList() {
    const [showModal, setShowModal] = useState(false);
    const { showModal: showModalDelete, toggleShowModal: toggleShowModalDelete } = useModal();
    const [loading, setLoading] = useState(false);
    const [deleteResponse, setDeleteResponse] = useState<boolean>(false);
    const [itemToDelete, setItemToDelete] = useState<string>("");
    const [pleaList, setPleaList] = useState<PaginationModel<PleaModel[]>>();
    const { id } = useParams();
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');

    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: string,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex: string): ColumnType<PleaModel> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Buscar ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Limpar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) => {
            const item = dataIndex.includes('.')
                ? dataIndex.split('.').reduce((o: any, i) => o?.[i], record)
                : (record as any)[dataIndex];
            return item?.toString().toLowerCase().includes((value as string).toLowerCase());
        },
    });
    async function getAllPlea(page?: number) {
        try {
            setLoading(true);
            await GetAllPleaPaginatedAPI(id ?? "", page).then((resp: any) => {
                setPleaList(resp.data);
            });
        }
        catch (error: any) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }
    const DeleteProjectHistory = async (pleaId: string) => {
        try {
            setLoading(true);
            await DeletePleaAPI(pleaId).then((resp: IResponseProps) => {
            }).finally(() => {
                setLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            setLoading(false);
        }
        getAllPlea();
    }
    useEffect(() => {
        if (id != undefined && id !== "") {
            getAllPlea();
        }
    }, [id]);
    useEffect(() => {
        if (deleteResponse && itemToDelete !== "") {
            const pleaId = (pleaList?.items.find(item => item.id === itemToDelete))?.id;
            if (pleaId !== undefined) {
                DeleteProjectHistory(itemToDelete)
            }
            setItemToDelete("");
            setDeleteResponse(false);
        } else if (itemToDelete !== "") {
            setItemToDelete("");
        }
    }, [deleteResponse]);
    const columns = [
        {
            title: 'Versão',
            dataIndex: 'version',
            key: 'version',
            width: 100,
            ...getColumnSearchProps('version'),
            sorter: (a: PleaModel, b: PleaModel) => a.version - b.version,
        },
        {
            title: 'Banco de Fomento',
            dataIndex: 'bankName',
            key: 'bankName',
            width: 200,
            ...getColumnSearchProps('bankName'),
            sorter: (a: PleaModel, b: PleaModel) => a.bankName.localeCompare(b.bankName),
        },
        {
            title: 'Agrupamento',
            dataIndex: ['projectsGrouping', 'name'],
            key: 'grouping',
            ...getColumnSearchProps('projectsGrouping.name'),
            sorter: (a: PleaModel, b: PleaModel) =>
                a.projectsGrouping.name.localeCompare(b.projectsGrouping.name),
        },
        {
            title: 'Painel Correspondente',
            dataIndex: 'panel',
            key: 'panel',
            render: () => '100%',
        },
        {
            title: 'Ano Referência',
            dataIndex: ['projectsGrouping', 'year'],
            key: 'year',
            width: 150,
            ...getColumnSearchProps('projectsGrouping.year'),
            sorter: (a: PleaModel, b: PleaModel) => a.projectsGrouping.year - b.projectsGrouping.year,
        },
        {
            title: 'Ações',
            key: 'actions',
            width: 150,
            align: 'center' as const,
            render: (_: any, record: PleaModel) => (
                <Space size="middle" style={{ gap: '8px' }}>
                    <Link to={`/plea/financial/finep/${record.id}/${id}`}>
                        <Button
                            type="text"
                            icon={<EditOutlined style={{ color: '#1890ff' }} />}
                        />
                    </Link>
                    <Button
                        type="text"
                        danger
                        onClick={() => { setItemToDelete(record.id); toggleShowModalDelete() }}
                        icon={<DeleteOutlined />}
                    />
                </Space>
            ),
        },
    ];
    return (
        <>
            {loading && <Loader />}
            <ModalDelete show={showModalDelete} toggleShow={toggleShowModalDelete} setResponse={setDeleteResponse} />
            <Card
                style={{ margin: '0 10px' }}
                title={
                    <CardHeader
                        pageName={"Cadastro"}
                        hasPageBefore={false}
                    />
                }
            >
                <Button
                    type="primary"
                    onClick={() => setShowModal(true)}
                    style={{
                        width: '100%',
                        marginBottom: 16,
                        borderRadius: 10
                    }}
                    icon={<PlusOutlined />}
                >
                    Novo Cadastro
                </Button>
                <Table
                    columns={columns}
                    dataSource={pleaList?.items}
                    bordered={false}
                    pagination={false}
                    locale={{
                        emptyText: pleaList ? <FillTable columns={5} rows={0} /> : null
                    }}
                    components={{
                        header: {
                            cell: (props: any) => <th {...props} style={{ borderRight: 'none' }} />,
                        },
                        body: {
                            cell: (props: any) => <td {...props} style={{ borderRight: 'none' }} />,
                        }
                    }}
                />
                <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
                    <TablePaginationFooter
                        totalItems={pleaList?.total ?? 0}
                        change={getAllPlea}
                    />
                </div>
            </Card>
            <CreatePleaModal
                setShowModal={setShowModal}
                showModal={showModal}
                getAllPlea={getAllPlea}
            />
        </>
    )
}